
    <!------------save card dropdown---------------->
    <div class="save-card__details" *ngIf="cardsData?.length">
        <button  class="save-card--button" [ngClass]="selectedCard ? 'save-card--selected' : ''" (click)="showListOfCards()">
            <div class="save-card--content">
                <div class="save-card--title">
                    <h5 *ngIf="!selectedCard && !isAddNewButtonClicked" class="save-card--heading">{{'savedCards.savedCardTitle' | translate}}</h5>
                    <h5 *ngIf="selectedCard && !isAddNewButtonClicked" class="selected-card--heading">{{'savedCards.selectedCardTitle' | translate}} </h5>
                    <h5 *ngIf="!selectedCard && isAddNewButtonClicked" class="add-card--heading">{{'savedCards.addNewCardTitle' | translate}}</h5>
                    <h4 class="save-card--number">{{selectedCard?.maskedAccount}}</h4>
                </div>
                <i class="icon icon-dropdown-arrow save-card--dropdownIcon"></i>
            </div>
        </button>
        <div class="save-card__list " [ngClass]="isShowList ? 'active':''">
            <ul>
                <ng-container *ngFor="let card of cardsData">
                    <li data-value="1" class="save-card__list-item" *ngIf="!card.isEditEnabled" (click)="updateCard($event,card)">
                        <h4 class="save-card--number">{{card.maskedAccount}}</h4>
                        <h6 class="save-card--remove" (click)="removedClicked($event, card)">{{'savedCards.removeButton' | translate}}</h6>
                    </li>
                    <li data-value="2" class="remove-save--card active" *ngIf="card.isEditEnabled">
                        <button class="save-card--deleteBtn" (click)="deleteCard(card)">{{'savedCards.deleteButton' | translate}}</button>
                        <h4>{{card.maskedAccount}}</h4>
                        <button class="save-card--cancelBtn" (click)="removedClicked($event, card)">{{'savedCards.cancelButton' | translate}}</button>
                    </li>
                </ng-container>
            </ul>
            <div class="save-card__list--addnewBtn" (click)="addNewCard()">
                    {{'savedCards.addNewCardInList' | translate}}
            </div>
           
        </div>

        <!------------save card CVV Input field---------------->
        <form [formGroup]="savedCardForm" *ngIf="selectedCard">
        <div class="save-card--cvv__inputfield form-group" >
            <div class="payment-cashier--inputContent payment-input icn-input icn-card-cvv controls {{validationClass}}">
                <input formControlName="cardCvv" (blur)="checkErrorValidation()" (input)="getErrorMessage()"class="floatLabel form-control inputWithoutDecimal" type="text" placeholder="" (keydown)="checkLengthOfTheElement($event)">
                <label for="Card number">{{'creditCard.cardCvv' | translate}}</label>
            </div>
            <app-custom-error-message *ngIf="transactionMessage && (isOnBlur || isSubmitted) && selectedCard && isBelowe_480" class="error-message--wrapper"  [message]="transactionMessage" ></app-custom-error-message>
            <div class="save-card--addnewCardBtn" [ngClass]="isShowList ? 'hidden' : ''">
                <button (click)="addNewCard()">{{'savedCards.addNewCardButton' | translate}}</button>
            </div>
       
        </div>
    </form>
    <app-custom-error-message *ngIf="transactionMessage && (isOnBlur || isSubmitted) && selectedCard && !isBelowe_480" class="error-message--wrapper"  [message]="transactionMessage" ></app-custom-error-message>
        <!------------save card CVV Input field---------------->
    </div>

    <!------------save card dropdown---------------->

